/**
 * Normaliza as respostas de coleção do backend, que variam de envelope entre
 * endpoints:
 *
 *   - array puro:            `[ {...}, {...} ]`
 *   - envelope SuccessOutput: `{ data: [ ... ] }`
 *   - envelope OData-like:    `{ value: [ ... ], Count: n }`  (ex.: /irrfs, /iofs)
 *   - objeto único:           `{ ... }`  (quando há apenas um registro)
 *
 * Usar em lookups novos no lugar do `Array.isArray(res) ? res : res.data`
 * espalhado pelos services antigos, que não cobre `value` nem objeto único.
 */
export function unwrapCollection<T = any>(response: unknown): T[] {
    if (response === null || response === undefined) {
        return [];
    }

    if (Array.isArray(response)) {
        return response as T[];
    }

    if (typeof response === 'object') {
        const envelope = response as Record<string, unknown>;

        if (Array.isArray(envelope['data'])) {
            return envelope['data'] as T[];
        }

        if (Array.isArray(envelope['value'])) {
            return envelope['value'] as T[];
        }

        // Registro único devolvido fora de um array.
        return [response as T];
    }

    return [];
}
